import React, { FC, useEffect, useState} from "react";
import { Row, Collapse, Col } from "antd";
import { cloneDeep } from "lodash";
import Modal from "antd/lib/modal/Modal";

import ProgressCard from "@pages/member-details/progress-with-subheading";
import NonCanonicalRisk from "@pages/member-details/non-clinical-risk";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import MultiLineChart from "@pages/member-details/risk-score/multiline-chart";
import CustomTooltip from "@pages/tool-tip";

const { Panel } = Collapse;

const HealthMeasure: FC<any> = (props) => {

  const dataCardId = "25";

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeCardPanel, setActiveCardPanel] = useState<any[]>(props?.activeKey?.includes(dataCardId) ? ["1"] : []);

  useEffect(()=> {
    setActiveCardPanel(props.activeKey?.includes(dataCardId) ? ["1"] : [])
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else
    props.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = (e:any) => {
    e.stopPropagation();
    setIsModalVisible(false);
  };

  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );


  const genExtra = (id:any) => (
      <>
        <Row>
          {
            props?.chartData?.length > 0 && 
              <Col
                style={{ marginRight: "16px" }}
                className="link clr-blueLink"
                onClick={(e) => {
                  showModal();
                  e.stopPropagation();
                }}
                >
                <i
                  style={{ verticalAlign: "middle", marginRight: 10 }}
                  className="icon icon-bar-chart"
                ></i>
                View Chart
              </Col>
          }
          <Modal title="Severity Over Time" visible={isModalVisible} onCancel={(e)=>handleCancel(e)} width={846} style={{height:"410px"}} footer={null}>
          <p><MultiLineChart data={props?.chartData}/></p>
        </Modal>

          <Col>
          <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
      pinCardIds={props.pinCardIds}/>
          </Col>
        </Row>
      </>
  );

  return (
    <>
      <Collapse
        accordion={true}
        activeKey={activeCardPanel}
        expandIconPosition="right"
        bordered={false}
        onChange={onCollapseChange}
      >
        <Panel
          className="title"
          header={getHeading("Health Measures")}
          key="1"
          extra={genExtra(props?.data?.dataCardId)}
          style={{marginBottom: "8px"}}
        >
          <Row gutter={16}>
            <Col span={8}>
              <ProgressCard
                size={24}
                cardHeight={278}
                name="HCC Score YTD"
                value={props?.data?.hccRisk?.currentValue}
                percentVal={props?.data?.hccRisk?.scorePercentage?.replace("%","")}
                info={`${props?.data?.hccRisk?.lastMonth} last month`}
                percent={props?.data?.hccRisk?.percentageChange}
                scoreRange={props?.data?.hccRisk?.scoreRange}
                scoreFlag={props?.data?.hccRisk?.scoreFlag}
              />
              
            </Col>
            <Col span={16}>
              <NonCanonicalRisk
                size={24}
                cardHeight={278}
                percent={"0%-100%"}
                value={props?.data?.nonClinicalRisk}
              />
              {/* <Card>
              <Row>
                <Col span={24}>
                  <span>Non clinical Risk</span>
                </Col>
                </Row>
                <ProgressCard
                  size={10}
                  cardHeight={278}
                  value={riskScores.healthMeasures.nonClinicalRisk.nonClinical}
                  percent={riskScores.healthMeasures.nonClinicalRisk.percent}
                  info={riskScores.healthMeasures.nonClinicalRisk.info}
                >
                  <ProgressCard
                          size={7}
                          value={
                            riskScores.healthMeasures.nonClinicalRisk.sdoh.sdoh
                          }
                        />
                        <ProgressCard
                          size={7}
                          name="A2C (Average)"
                          value={
                            riskScores.healthMeasures.nonClinicalRisk.a2c.a2c
                          }
                        />
                  </ProgressCard>
                       
            </Card> */}
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </>
  );
};

export default HealthMeasure;
